import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { User, LogOut, Settings, Users, Building, BarChart3, FolderOpen, Calculator } from 'lucide-react';

interface UserMenuProps {
  usuario: {
    nombre: string;
    email: string;
    rol: string;
  } | null;
}

export function UserMenu({ usuario }: UserMenuProps) {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  if (!usuario) return null;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" className="flex items-center gap-2">
          <div className="h-8 w-8 rounded-full bg-primary/10 flex items-center justify-center">
            <User className="h-4 w-4 text-primary" />
          </div>
          <div className="hidden sm:block text-left">
            <p className="text-sm font-medium">{usuario.nombre}</p>
            <p className="text-xs text-muted-foreground capitalize">{usuario.rol}</p>
          </div>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        <DropdownMenuLabel>
          <div>
            <p className="font-medium">{usuario.nombre}</p>
            <p className="text-xs text-muted-foreground">{usuario.email}</p>
          </div>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={() => navigate('/analitica')}>
          <BarChart3 className="h-4 w-4 mr-2" />
          Analitica
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        {usuario.rol === 'admin' && (
          <DropdownMenuItem onClick={() => navigate('/admin/usuarios')}>
            <Users className="h-4 w-4 mr-2" />
            Administrar Cuentas
          </DropdownMenuItem>
        )}
        {usuario.rol === 'admin' && (
          <DropdownMenuItem onClick={() => navigate('/admin/suppliers')}>
            <Building className="h-4 w-4 mr-2" />
            Equivalencias
          </DropdownMenuItem>
        )}
        {usuario.rol === 'admin' && (
          <DropdownMenuItem onClick={() => navigate('/admin/servicios')}>
            <FolderOpen className="h-4 w-4 mr-2" />
            Servicios
          </DropdownMenuItem>
        )}
        {usuario.rol === 'admin' && (
          <DropdownMenuItem onClick={() => navigate('/admin/codigos-contables')}>
            <Calculator className="h-4 w-4 mr-2" />
            Codigos Contables
          </DropdownMenuItem>
        )}
        {usuario.rol === 'admin' && (
          <DropdownMenuItem onClick={() => navigate('/admin/configuracion')}>
            <Settings className="h-4 w-4 mr-2" />
            Configuracion
          </DropdownMenuItem>
        )}
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={handleLogout} className="text-red-600">
          <LogOut className="h-4 w-4 mr-2" />
          Cerrar Sesion
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
